'use client';

import { ButtonBaseClasses } from '@/components/_rebrand/Button';
import ThemeWrapper from '@/components/_rebrand/ThemeWrapper';
import { ThemeNameType } from '@/tailwind-config/theme.constants';
import cn from 'classnames';
import { FC } from 'react';

export type ButtonPlayProps = {
  text?: string;
  onClick?: () => void;
  className?: string;
  theme?: ThemeNameType;
};

const PlayIcon: FC = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16667 0C4.10406 0 0 4.10406 0 9.16667C0 14.2293 4.10406 18.3333 9.16667 18.3333C14.2293 18.3333 18.3333 14.2293 18.3333 9.16667C18.3333 4.10406 14.2293 0 9.16667 0ZM7.16645 5.93007C7.08333 6.04109 7.08333 6.23996 7.08333 6.6377V11.6955C7.08333 12.0932 7.08333 12.2921 7.16645 12.4031C7.23889 12.4999 7.34976 12.5604 7.47032 12.569C7.60865 12.5789 7.77594 12.4713 8.1105 12.2563L12.0443 9.72737C12.3347 9.54074 12.4798 9.44742 12.53 9.32876C12.5738 9.22508 12.5738 9.10809 12.53 9.00441C12.4798 8.88576 12.3347 8.79244 12.0443 8.6058L8.11051 6.07691C7.77594 5.86183 7.60865 5.75429 7.47032 5.76417C7.34976 5.77278 7.23889 5.83332 7.16645 5.93007Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * ButtonPlay is the pill-shaped "Watch Now" play button used on top of
 * video posters. It always renders against the Dark Violet color tokens
 * (citron surface + blue-900 text) regardless of the surrounding theme,
 * matching the Figma "Button Play" component.
 */
export const ButtonPlay: FC<ButtonPlayProps> = ({
  text = 'Watch Now',
  onClick,
  className,
  theme = 'theme-dark-violet',
}) => {
  return (
    <ThemeWrapper theme={theme}>
      <button
        type="button"
        onClick={onClick}
        className={cn(
          ButtonBaseClasses,
          'button-surface button-text-default hover:button-surface-active',
          'inline-flex items-center gap-2xs px-s py-xs',
          className,
        )}
      >
        <PlayIcon />
        {text}
      </button>
    </ThemeWrapper>
  );
};

export default ButtonPlay;
